import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LoadingSplashScreenDialogComponent } from '../../pages/components/loading-splash-screen-dialog/loading-splash-screen-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class LoadingSplashScreenService {
  private spinnerFormConfig: MatDialogConfig;
  private dialogRefId: string;

  constructor(private dialog: MatDialog) {
    this.spinnerFormConfig = new MatDialogConfig();
    this.spinnerFormConfig.disableClose = true;
    this.spinnerFormConfig.autoFocus = true;
    this.spinnerFormConfig.minWidth = '100%';
    this.spinnerFormConfig.maxWidth = '100%';
    this.spinnerFormConfig.width = '100%';
    this.spinnerFormConfig.minHeight = '100%';
    this.spinnerFormConfig.maxHeight = '100%';
    this.spinnerFormConfig.height = '100%';
  }

  public isPresenting(): boolean {
    return !!this.dialogRefId;
  }

  public present(timeout: number = null): Promise<string> {
    // if timeout is given, this spinner will be auto dismissed after 'timeout' ms
    return new Promise<string>((resolve) => {
      setTimeout(() => {
        const dialogRef = this.dialog.open(
          LoadingSplashScreenDialogComponent,
          this.spinnerFormConfig
        );

        this.dialogRefId = dialogRef.id;

        if (timeout && timeout > 0) {
          this.dismiss(timeout);
        }
        resolve(this.dialogRefId);
      });
    });
  }

  public dismiss(timeout: number = null): void {
    if (!this.dialogRefId) {
      return;
    }

    const dialogRef = this.dialog.getDialogById(this.dialogRefId);
    if (dialogRef) {
      if (timeout && timeout > 0) {
        setTimeout(() => {
          dialogRef.close();
          this.dialogRefId = null;
        }, timeout);
      } else {
        try {
          dialogRef.close();
          this.dialogRefId = null;
        } catch (e) {
          console.error(e);
        }
      }
    }
  }
}
